

import { Component, Vue,Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import Pagination from "@/components/Pagination/index.vue";
import { OderService, OrderDto, OrderStatisticDto, RoleEditDto } from "@/api/service-proxies";
import uploadTracking from '../components/UploadtrackingDialog.vue'

import returnsDialog from '../components/ReturnsDialog.vue'
import XLSX, { WorkSheet } from 'xlsx'
import PagedListBase, {
  PagedRequestDto
} from "@/lib/view-base/paged-list-base";

class TenantPagedRequest extends PagedRequestDto {
  orderNumber!: string;
  code!: string;
  companyNumber!: string;
  ReceName!: string;
  ReceMobile!: string;
  createTime!: moment.Moment;
  createTime2!: moment.Moment;
  list = [];
  OrderRecordState:number
}

@Component({
  name: "Tenant",
  components: {
    Pagination,
    uploadTracking,
    returnsDialog
  }
})
export default class Tenant extends PagedListBase<
  TenantPagedRequest,
  OrderDto
> {
  request = new TenantPagedRequest();
  name = ''
  OderService = new OderService();
  value = null
  // 搜索商品类型
  optionsType:any = [];
  pickerOptions = {
    shortcuts: [{
      text: '最近一周',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近一个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近三个月',
      onClick(picker) {
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        picker.$emit('pick', [start, end]);
      }
    }]
  }
  topTypeNum = new OrderStatisticDto
  value2 = null
  list = []
  created() {
    this.refresh();
    this.getStatistical()
    this.InitOrder();

  }

  getpage(finishCallback: Function): void {
    this.OderService
      .getAll(
        this.request.orderNumber,
        this.request.OrderRecordState,
        this.request.companyNumber,
        this.request.ReceName,
        this.request.ReceMobile,
        this.request.createTime,
        this.request.createTime2,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {
        result.items.forEach((e)=>{
          if(e.orderDetails[0] != null && e.orderDetails[0].product != null){
            e.orderDetails[0].product.p_Path = (this as any).$aes.imgAddAuth(e.orderDetails[0].product.p_Path);
          }
        })
        this.list = result.items;
        this.showPaging(result);

      })
      .finally(() => {
        finishCallback();
      });
  }
  getStatistical() {
    this.OderService.getOrderStatistics()
      .then((res) => {
        this.topTypeNum = res
      })
      .catch(() => {
        this.$message.error('获取各状态数量失败')
      })
  }
  // 上传快递单号
  updateTracking(row) {
    if (row.orderRecordState == 4) {
      this.$message.warning('该订单已发货')
      return
    };
    (this.$refs.uploadTrackingRef as uploadTracking).open(row.orderNumber)
  }

  returnsOrder(row) {

    (this.$refs.returnsDialogRef as returnsDialog).open(row.orderNumber)
  }
  handleCreate() {
    this.$router.push({ path: "/pro/Oder/create" });
  }
  // 跳转详情页面
  gotoDetails(id) {
    this.$router.push({ name: "orderDetails", params: { id: id + '' }, })
  }
  handleUpdate(Oder: OrderDto) {
    this.$router.push({ path: `/pro/Oder/update/${Oder.id}` });
  }
  handleDelete(Oder: OrderDto) {
    this.$confirm("确定删除产品?")
      .then(async () => {
        await this.OderService.delete(Oder.id);
        this.$notify.success("删除成功");
        this.refresh();
      })
      .catch(() => { });
  }

  //状态改变事件
  statusSwitchChange(Oder: OrderDto) {

    // this.OderService.OderSwitchChange(Oder);

  }


  dateTimeChange(event: any) {
    if (event) {
      this.request.createTime = event[0];
      this.request.createTime2 = event[1];
    } else {
      this.request.createTime = null;
      this.request.createTime2 = null;
    }
  }

  InitOrder(){
    this.OderService.getOrderStateData().then(result=>{

      this.optionsType=result;

    })

  }
  private async handleExportResult() {

      const result = this.OderService
      .getAll(
        this.request.orderNumber,
        this.request.OrderRecordState,
        this.request.companyNumber,
        this.request.ReceName,
        this.request.ReceMobile,
        this.request.createTime,
        this.request.createTime2,
        this.request.sorting,
        this.request.skipCount,
        this.request.maxResultCount
      )
      .then(result => {


      this.exportExcel(result.items)

      })
      .finally(() => {

      });
}
  private exportExcel(rows: OrderDto[]) {
    let excelRows = [
      ['商品名称', '规格', '数量', '收货人', '联系电话', '收货地址', '支付状态', '支付时间', '订单号', '流水号']
    ]
    for (const row of rows) {
            // 将 Moment 对象转换为字符串
        let paidTimeStr = '';
        if (row.paidTime && row.paidTime.isValid && row.paidTime.isValid()) {
          paidTimeStr = row.paidTime.format('YYYY-MM-DD HH:mm:ss');
        } else if (row.paidTime) {
          // 如果不是 Moment 对象但有值，尝试直接转换
          paidTimeStr = String(row.paidTime);
        }
      excelRows.push([
        row.orderDetails[0].product.name,
        row.orderDetails[0].productSpecifications.specName,
        row.orderDetails[0].num.toString(),
        row.address == null?"":row.address.name,
        row.address == null?"":row.address.phone,
        row.address == null?"":row.address.getAdreesDetail,
        this.getOrderStatusText(row.orderRecordState),
        paidTimeStr,
        row.orderNumber,
        row.serialNo
      ])
    }
    let workSheet = XLSX.utils.aoa_to_sheet(excelRows)
// 设置标题样式 - 居中对齐
workSheet['A1'].s = {
  alignment: {
    horizontal: 'center',
    vertical: 'center'
  },
  font: {
    bold: true,
    sz: 16
  }
};
// 设置表头样式 - 居中对齐
const headerCells = ['A2', 'B2', 'C2', 'D2', 'E2', 'F2', 'G2', 'H2', 'I2', 'J2'];
headerCells.forEach(cell => {
  if (workSheet[cell]) {
    workSheet[cell].s = {
      alignment: {
        horizontal: 'center',
        vertical: 'center'
      },
      fill: {
        fgColor: { rgb: "4472C4" }
      },
      font: {
        color: { rgb: "FFFFFF" },
        bold: true
      }
    };
  }
});
    let workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, workSheet, '订单列表')
    workSheet['!cols'] = [
      { wpx: 150 },
      { wpx: 90 },
      { wpx: 90 },
      { wpx: 130 },
      { wpx: 90 },
      { wpx: 150 },
      { wpx: 60 },
      { wpx: 100 },
      { wpx: 100 },
      { wpx: 160 }
    ]
    XLSX.writeFile(workbook, '订单导出.xlsx')
  }


   getOrderStatusText (state)
    {
  switch (state) {
    case 1:
      return '待支付';
    case 2:
      return '已支付';
    case 3:
      return '待发货';
    case 4:
      return '已发货';
    case 5:
      return '已退货';
    case 6:
      return '已完成';
    case 7:
      return '已取消';
    case 8:
      return '申请退订';
    case 9:
      return '拒绝退订';
    default:
      return '未知状态';
  }
};
}
